import { twMerge } from "tailwind-merge";

interface UserAvatarProps {
  src?: string;
  alt?: string;
  size?: number;
  isRounded?: boolean;
}

const AVATAR_FALLBACK = "/images/default_user_image.png";

export default function UserAvatar({
  src,
  alt = "유저 프로필 사진",
  size = 150,
  isRounded = true,
}: UserAvatarProps) {
  return (
    <img
      style={{ width: size }}
      src={src || AVATAR_FALLBACK}
      alt={alt}
      onError={(event) => {
        event.currentTarget.src = AVATAR_FALLBACK;
      }}
      className={twMerge(
        "aspect-square overflow-hidden object-cover",
        isRounded && "rounded-full"
      )}
    />
  );
}
